<template>
  <router-view></router-view>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
export default {
  created() {
    modifyNetTitle('索赔登记')
  },
};
</script>
<style lang="scss" scoped></style>
